import { trendingBriefs, heatTags } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

const TAG_STYLE: Record<string, string> = {
  '塌房': 'bg-primary-100 text-primary-700',
  '翻车': 'bg-accent-100 text-accent-700',
  '争议': 'bg-secondary-200 text-secondary-800',
  '曝光': 'bg-foreground-100 text-foreground-700',
};

export default function TrendingSection() {
  return (
    <section id="trending" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-2.5 py-1 text-xs font-medium">
                  <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
                  今日速递
                </span>
                <span className="text-xs text-foreground-500">热度每 15 分钟刷新</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight">
                塌房热榜 <span className="text-primary-600">Top10</span>
              </h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600 leading-relaxed">
                黑料曝光、负面事件与争议的口径统一榜单，按全网讨论增量实时排序。标题即摘要，点开看证据链与完整时间线。
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              {heatTags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-3">
          {trendingBriefs.map((it, idx) => (
            <Reveal key={it.id} delay={(idx % 5) * 40}>
              <a
                href="#featured"
                className="group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 rounded-md bg-background-50 border border-background-200/70 p-3.5 md:p-4 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center gap-3 sm:gap-4 flex-1 min-w-0">
                  <span
                    className={`font-heading text-2xl md:text-3xl font-bold shrink-0 w-9 md:w-10 text-center ${
                      it.rank <= 3 ? 'text-primary-600' : 'text-secondary-300'
                    }`}
                  >
                    {String(it.rank).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${TAG_STYLE[it.tag]}`}>
                        {it.tag}
                      </span>
                      <h3 className="font-heading text-[15px] md:text-base font-semibold leading-snug group-hover:text-primary-700 transition-colors">
                        {it.title}
                      </h3>
                    </div>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 hidden sm:line-clamp-1">
                      {it.summary}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between sm:justify-end gap-4 sm:gap-5 shrink-0 sm:pl-4">
                  <div className="text-right">
                    <div className="text-xs text-foreground-500">热度</div>
                    <div className="font-medium text-sm whitespace-nowrap">{it.heat}</div>
                  </div>
                  <div
                    className={`flex items-center gap-1 text-xs rounded-full px-2 py-0.5 ${
                      it.delta >= 0
                        ? 'text-primary-600 bg-primary-50'
                        : 'text-foreground-400 bg-background-100'
                    }`}
                  >
                    <i className={`w-4 h-4 flex items-center justify-center ${it.delta >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`} />
                    {Math.abs(it.delta)}
                  </div>
                  <span className="hidden lg:flex items-center justify-center w-8 h-8 rounded-full bg-background-100 text-foreground-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}